import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DecksFences from "../pages/decks-fences/page";
import PropertyMaintenance from "../pages/property-maintenance/page";
import HomeRenovations from "../pages/home-renovations/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/decks-fences",
    element: <DecksFences />,
  },
  {
    path: "/property-maintenance",
    element: <PropertyMaintenance />,
  },
  {
    path: "/home-renovations",
    element: <HomeRenovations />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;